import React, { ChangeEvent, useState } from 'react';
import { BsSearch } from 'react-icons/bs';
import { FaArrowLeft } from 'react-icons/fa';
import { useSteps } from '../../contexts/stepContext';
import { Title } from '../../styles/global';
import { warnToast } from '../../utils/toast';
import { Content, GoBack } from '../BodyStep/styles';
import Button from '../Button';
import { Container, Message, SearchContainer, SearchInput } from './styles';

const ListPlatesBD: React.FC = () => {
  const [pageConvert, setPageConvert] = useState(0);

  const {
    handleReturnCurrentStep,
    handleChangeCurrentStep,
    numberPerPage,
    setNumberPerPage,
    getListPlatesPerPage,
    inputValue,
    setInputValue,
  } = useSteps();

  async function valuePageChange(e: ChangeEvent<HTMLInputElement>) {
    setNumberPerPage(e.target.value);
    setInputValue(e.target.value);
    setPageConvert(Number(e.target.value));
  }

  const validatePlatesPerPage = () => {
    if (numberPerPage === '') {
      warnToast('Por favor preencha a quantidade de placas por página.');
      return;
    }
    if (pageConvert > 50) {
      warnToast(
        'Recomendamos que insira um número menor de elementos por página',
      );
      setNumberPerPage('');
      return;
    }

    getListPlatesPerPage();
    handleChangeCurrentStep();
  };

  return (
    <Content>
      <GoBack onClick={handleReturnCurrentStep}>
        <FaArrowLeft size={16} />
        voltar
      </GoBack>
      <Title>Listar Placas</Title>
      <Container>
        <SearchContainer>
          <Message>
            Informe a quantidade placas que você deseja visualizar por página
          </Message>
          <SearchInput
            placeholder="Ex: 3, 5, 7, 10"
            autoFocus
            value={inputValue}
            onChange={valuePageChange}
          />
        </SearchContainer>
      </Container>
      <Button title="Buscar" onClick={validatePlatesPerPage} icon={BsSearch} />
    </Content>
  );
};

export default ListPlatesBD;
